import { useI18n } from 'vue-i18n';
import { specialties } from '~/models/specialties';

export const getSpecialties = () => {
    const { t } = useI18n();
    return specialties.map((specialty) => {
        return {
            label: t(`specialties_types.${specialty.toLowerCase()}`),
            value: specialty
        };
    })
        .sort((a, b) => a.label.localeCompare(b.label));
}